<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Transfer No：{{
            formData.mrpStockTransferNo ? formData.mrpStockTransferNo : 'New'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.stockTransferStatus === 'Y'
              ? 'success'
              : formData.stockTransferStatus === 'D'
              ? 'warning'
              : 'primary'
          "
        >
          {{ formData.v_stockTransferStatus || 'New' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_transferDate') || '转库日期'"
            prop="transferDate"
          >
            <el-date-picker
              v-model="formData.transferDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_transferType') || '转库类型'"
            prop="transferType"
          >
            <dict-select
              filterable
              size="mini"
              clearable
              v-model="formData.transferType"
              :body="{ dictType: 'transferType' }"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_outWarehouse') || '出库仓库'"
            prop="outwarehouseCode"
          >
            <dict-select
              clearable
              v-model="formData.outwarehouseCode"
              :selectedLabel.sync="formData.outWarehouseName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="mini"
              url="/ecom/warehouse/cn/warehouse/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_inWarehouse') || '入库仓库'"
            prop="inWarehouseCode"
          >
            <dict-select
              clearable
              v-model="formData.inWarehouseCode"
              :selectedLabel.sync="formData.inWarehouseName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="mini"
              url="/ecom/warehouse/cn/warehouse/select"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <MaterialBatchTable
          ref="materialBatchTable"
          :disabled="disabled"
          :tableData="formData.mrpStockTransferDetailList"
        />
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" v-if="!disabled" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import MaterialBatchTable from '../material-batch-table'
export default {
  mixins: [EditLoading],
  components: {
    MaterialBatchTable,
  },
  props: {
    mrpStockTransferCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        transferDate: [
          {
            required: true,
            message: this.$l('form_label_tip_transferDate') || '请选择转库日期',
            trigger: 'change',
          },
        ],
        transferType: [
          {
            required: true,
            message: this.$l('form_label_tip_transferType') || '请选择转库类型',
            trigger: 'change',
          },
        ],
        outwarehouseCode: [
          {
            required: true,
            message: this.$l('form_label_tip_outWarehouse') || '请选择出库仓库',
            trigger: 'change',
          },
        ],
        inWarehouseCode: [
          {
            required: true,
            message: this.$l('form_label_tip_inWarehouse') || '请选择入库仓库',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {},
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.mrpStockTransferCode) return
      this.$api
        .mrpStockTransferDetailApi({
          mrpStockTransferCode: this.mrpStockTransferCode,
        })
        .then((res) => {
          const { body } = res
          this.formData = {
            ...body,
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      const materialBatchResult = await this.$refs.materialBatchTable.validate()
      if (!result || !materialBatchResult)
        return (this.backDialogVisible = false)

      const { outwarehouseCode, inWarehouseCode } = this.formData
      if (outwarehouseCode === inWarehouseCode) {
        this.$message.warning(
          this.$l('form_label_same') || '出库仓库 与 入库仓库 相同'
        )
        return
      }
      this.formData.mrpStockTransferDetailList = this.$refs.materialBatchTable.getTableData()
      this.loadingOpen()
      this.$api
        .mrpStockTransferSaveApi(this.formData)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
